import axios from 'axios';
import authHeader from '../auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/team/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/team/';

class TeamService {
  getTeam(teamId) {
    return axios.get(API_URL  + teamId);
  }

  getTeamInfo(teamId) {
    return axios.get(API_URL  + 'info/'+ teamId);
  }

  getTeamAvgStats(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/${seasonId}/average-stats`);
  }

  getPlacer(teamId) {
    return axios.get(API_URL  + 'placer/'+ teamId);
  }

  getCurrentRoster(teamId) {
    return axios.get(API_URL  + 'current-roster/'+ teamId);
  }

  getInjuredRoster(teamId) {
    return axios.get(API_URL  + 'injured-players/'+ teamId);
  }

  getSuspendedRoster(teamId) {
    return axios.get(API_URL  + 'suspended-players/'+ teamId);
  }

  getCurrentYouthRoster(teamId) {
    return axios.get(API_URL  + 'current-youth-roster/'+ teamId);
  }

  getCurrentLoans(teamId) {
    return axios.get(API_URL  + 'current-loans/'+ teamId);
  }

  getAll(){
    return axios.get(API_URL );
  }

  getCurrentNationalRoster(countryId) {
    return axios.get(API_URL  + 'current-nation-roster/'+ countryId);
  }

  getTransfers(teamId) {
    return axios.get(API_URL  + teamId + '/transfers');
  }

  getGames(teamId,size = 999,sort="matchDate,desc") {
    return axios.get(API_URL  + teamId + '/games',{params:{size,sort}});
  }

  getGamesCalendar(teamId) {
    return axios.get(API_URL  + teamId + '/games/calendar');
  }

  getPreferredFormations(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/${seasonId}/preferred-formations`);
  }

  getTeamSubstitutions(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/substitutions`);
  }

  getTeamSetPiece(teamId, seasonId, acc) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/acc/${acc}/set-piece-and-avg`);
  }

  getTeamOPSP(teamId, seasonId, acc) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/acc/${acc}/open-play-and-set-piece`);
  }

  getIndividualAerialSetPieces(teamId, seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/aerial-set-piece`);
  }

  getTeamPossessions(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/possessions`);
  }

  getTeamFormations(teamId,seasonId,coachIds) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/coach-ids/${coachIds}/formations`);
  }

  getOppositeTeamFormations(teamId,seasonId,coachIds) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/coach-ids/${coachIds}/opposite-formations`);
  }

  getTeamCrossings(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/crossings`);
  }

  getTeamSetPieces(teamId,seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/set-piece`);
  }

  getTeamSeasonData(teamId, clientId) {
    return axios.get(API_URL + 'team-season-data/' + teamId + '/client/' + clientId);
  }

  getConnections(teamId,seasonIds){
    return axios.get(`${API_URL}${teamId}/connections`,{
      params: {
        seasonIds: seasonIds
      }
    });
  }

  getTeamTrends(teamId, seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/trends`);
  }

  getTeamHasVideo(teamId) {
    return axios.get(`${API_URL}${teamId}/has-video`);
  }

  getCoaches(teamId, seasonId) {
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/coaches`)
  }

  postTeam(team){
    return axios.post(`${API_URL}`,team);
  }

  postTeamFollow(userId, teamId) {
    return axios.post(API_URL + 'follow',
      {
        userId: userId,
        teamId: teamId
      }
     );
  }

  putTeamFollow(userId, teamId,subscribed) {
    return axios.put(API_URL + 'follow',
      {
        userId: userId,
        teamId: teamId,
        subscribed: subscribed
      }
     );
  }

  getFollowedTeams(userId,onlySelf) {
    return axios.get(API_URL + 'follow/' + userId, { params:{onlySelf} });
  }

  getTeamSetPieceReport(teamId, seasonId, from, to, gameIds = [0]) {
    return axios.get(`${API_URL}${teamId}/set-piece-report/season/${seasonId}/from/${from}/to/${to}/games/${gameIds}`)
  }

  getTeamAreasReport(teamId, seasonId, from, to, gameIds = [0]) {
    return axios.get(`${API_URL}${teamId}/areas-report/season/${seasonId}/from/${from}/to/${to}/games/${gameIds}`)
  }

  switchPinnedTeamFav(teamId, pinned){
    return axios.put(`${API_URL}${teamId}/pinned/${pinned}`);
  }
  
  getTeamsWithELO() {
    return axios.get(`${API_URL}elo`);
  }

  getTeamELoRanking() {
    return axios.get(`${API_URL}global/elo`);
  }

  getMultipleTeamsEloHistory(teamIds, dateFrom = null, dateTo = null) {
    const params = new URLSearchParams();
    
    if (Array.isArray(teamIds)) {
      teamIds.forEach(id => {
        params.append('teamIds', id);
      });
    }
    
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    
    return axios.get(`${API_URL}elo-history?${params.toString()}`);
  }

  getTopPlayers(teamId,seasonId,position,template,accumulation){
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/top-players`,{params:{position,template,accumulation}})
  }

  getArrigoTeamsByClient() {
    return axios.get(API_URL  + 'arrigo-teams');
  }

  getTeamTurnoversAndRecoveries(teamId, matchIds) {
    const params = new URLSearchParams();
    matchIds.forEach(id => {
      params.append("matchIds", id);
    });
    return axios.get(`${API_URL}${teamId}/turnovers-and-recoveries?${params.toString()}`);
  }

  getTeamPassingConnections(matchIds, minFrom, minTo, periodId, teamId) {
    const params = new URLSearchParams();
    if (matchIds) {
      matchIds.forEach(id => {
        params.append('matchIds', id);
      });
    }
    return axios.get(`${API_URL}${teamId}/pass-connections/from/${minFrom}/to/${minTo}/period/${periodId}?${params.toString()}`);
  }
  
  getOBREvents(seasonId,teamId){
    return axios.get(`${API_URL}${teamId}/season/${seasonId}/obr-events`)
  }

  getTeamGamesH2H(teamId, vsTeamId){
    return axios.get(`${API_URL}${teamId}/h2h-games/${vsTeamId}`);
  }

  getTeamConnectionsWithPlayerInfo(teamId, seasonId) {
    return axios.get(`${API_URL} ${teamId}/season/${String(seasonId)}/connections`);
  }

  getSimTeams(name, limit) {
    return axios.get(`${API_URL}similar/${limit}`,{
      params:{name}
    });
  }
}

export default new TeamService();


// WEBPACK FOOTER //
// ./src/services/team/team.service.js